<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-toolbar">
                <div>
                    <h4 class="text-primary">Vendor</h4>
                    <ol class="breadcrumb breadcrumb-card-header">
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0);" @click="backParent">Vendor</a>
                    </li>
                    <li class="breadcrumb-item active">
                        <span v-if="vendor.id === null">New</span>
                        <span v-else>
                        {{ vendor.vendor_no }}
                        </span>
                    </li>
                    </ol>
                    <button type="button" @click="updateVendor" class="btn btn-sm btn-soft-primary pull-left" v-show="vendor.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
                    <button type="button" @click="createVendor" class="btn btn-sm btn-soft-primary pull-left" v-show="vendor.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
                </div>
                </div>
            </div>
        </div>
        <div class="card card-list">
            <div class="card-header">
                <div class="col-md-12">
                    <h5 class="text-primary">
                        <span v-if="vendor.id === null">New</span>
                        <span v-else>{{ vendor.vendor_no }} - {{ vendor.name }}</span>
                        <span class="pull-right">Total Outstandings: {{ getTotalPurchasing - getTotalPayment | currency }}</span>
                    </h5>
                </div>
            </div>
            <div class="card-body">
                <ul class="nav nav-tabs nav-bordered">
                    <li class="nav-item">
                        <a href="#data-vendor" data-toggle="tab" aria-expanded="false" class="nav-link active">
                            Data
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#purchasing-tab" data-toggle="tab" aria-expanded="true" class="nav-link">
                            Purchasing
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#payment-tab" data-toggle="tab" aria-expanded="true" class="nav-link">
                            Payment
                        </a>
                    </li>
                </ul>
                <div class="tab-content">
                    <div class="tab-pane active" id="data-vendor">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label for="name" class="col-sm-3 col-form-label text-left">Type</label>
                                            <div class="col-sm-9">
                                                <select v-model="vendor.type_id" class="form-control">
                                                    <option v-for="v in vendorTypeList" :key="v.id" :value="v.id">{{ v.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="vendor.name" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="alias" class="col-sm-3 col-form-label text-left">Alias</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="vendor.alias" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="email" class="col-sm-3 col-form-label text-left">Email</label>
                                            <div class="col-sm-9">
                                                <input type="text" class="form-control" v-model="vendor.email"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="phone" class="col-sm-3 col-form-label text-left">Phone</label>
                                            <div class="col-sm-9">
                                                <input type="text" class="form-control" v-model="vendor.phone"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="mobile" class="col-sm-3 col-form-label text-left">Mobile</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="vendor.mobile" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="vat" class="col-sm-3 col-form-label text-left">Vat</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="vendor.vat" class="form-control"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label for="address" class="col-sm-3 col-form-label text-left">Address</label>
                                            <div class="col-sm-9">
                                                <textarea rows="5" v-model="vendor.address" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="state_id" class="col-sm-3 col-form-label text-left">State</label>
                                            <div class="col-sm-9">
                                                <select v-model="vendor.state_id" class="form-control">
                                                    <option v-for="c in stateList" :key="c.id" :value="c.id">{{ c.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="city_id" class="col-sm-3 col-form-label text-left">City</label>
                                            <div class="col-sm-9">
                                                <select v-model="vendor.city_id" class="form-control">
                                                    <option v-for="c in cityList" :key="c.id" :value="c.id">{{ c.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="postalcode" class="col-sm-3 col-form-label text-left">Postal Code</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="vendor.postalcode" class="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <hr>
                                    <div class="col-md-12">
                                        <h3>Contact</h3>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label for="contact_name" class="col-sm-3 col-form-label text-left">Name</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="contact.name" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="contact_email" class="col-sm-3 col-form-label text-left">Email</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="contact.email" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="contact_phone" class="col-sm-3 col-form-label text-left">Phone</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="contact.phone" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="contact_mobile" class="col-sm-3 col-form-label text-left">Mobile</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="contact.mobile" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="contact_vat" class="col-sm-3 col-form-label text-left">vat</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="contact.vat" class="form-control"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label for="contact_address" class="col-sm-3 col-form-label text-left">address</label>
                                            <div class="col-sm-9">
                                                <textarea cols="5" v-model="contact.address" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="contact_state_id" class="col-sm-3 col-form-label text-left">State</label>
                                            <div class="col-sm-9">
                                                <select v-model="contact.state_id" class="form-control">
                                                    <option v-for="c in stateList" :key="c.id" :value="c.id">{{ c.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="contact_city_id" class="col-sm-3 col-form-label text-left">City</label>
                                            <div class="col-sm-9">
                                                <select v-model="contact.city_id" class="form-control">
                                                    <option v-for="c in cityList" :key="c.id" :value="c.id">{{ c.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="contact_postalcode" class="col-sm-3 col-form-label text-left">Poostal Code</label>
                                            <div class="col-sm-9">
                                                <input type="text" v-model="contact.postalcode" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="contact_notes" class="col-sm-3 col-form-label text-left">Notes</label>
                                            <div class="col-sm-9">
                                                <textarea rows="5" v-model="contact.notes" class="form-control"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane" id="purchasing-tab">
                        <div class="row">
                            <div class="col-md-12">
                                <table class="table table-sm table-item">
                                    <thead>
                                        <th>Purchasing No.</th>
                                        <th>Date</th>
                                        <th>Product No</th>
                                        <th class="text-center">Qty</th>
                                        <th class="text-right">Price</th>
                                        <th class="text-right">Total</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="p in vendor.purchasing" :key="p.id">
                                            <td>
                                                <span style="color: blue; cursor: pointer;" @click="showPurchasingNo(p.purchasing_no)" data-toggle="modal" data-target="#modalPurchasing" data-backdrop="static" data-keyboard="false">{{ p.purchasing_no }}</span>
                                            </td>
                                            <td>{{ p.purchasing_date | dateFormat('DD/MM/YYYY') }}</td>
                                            <td><b>[{{ p.product_no }}]</b> {{ p.product }}</td>
                                            <td class="text-center">{{ p.qty }}</td>
                                            <td class="text-right">{{ p.price | currency }}</td>
                                            <td class="text-right">{{ p.qty * p.price | currency }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td class="text-right"><b>Total: </b></td>
                                            <td class="text-right"><b>{{ getTotalPurchasing | currency }}</b></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane" id="payment-tab">
                        <div class="row">
                            <div class="col-md-12">
                                <table class="table table-item mb-0 table-sm">
                                    <thead>
                                        <th>Purchasing No.</th>
                                        <th>Payment No.</th>
                                        <th>Group No.</th>
                                        <th>Date</th>
                                        <th>Notes</th>
                                        <th class="text-right">Total</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(p, index) in getPayment" :key="index">
                                            <td>
                                                <span style="color: blue; cursor: pointer;" @click="showPurchasingNo(p.purchasing_no)" data-toggle="modal" data-target="#modalPurchasing" data-backdrop="static" data-keyboard="false">{{ p.purchasing_no }}</span>
                                            </td>
                                            <td>
                                                <span><b>{{ p.payment_no }}</b></span>
                                            </td>
                                            <td>
                                                <span style="color: blue; cursor: pointer;" @click="showPaymentNo(p.group_no)" data-toggle="modal" data-target="#modalPaymentGroup" data-backdrop="static" data-keyboard="false">{{ p.group_no }} </span>
                                            </td>
                                            <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                            <td>{{ p.notes }}</td>
                                            <td class="text-right">{{ p.price | currency }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                <h5><b>Total:</b></h5>
                                            </td>
                                            <td class="text-right">
                                                <h5><b>{{ getTotalPayment | currency }}</b></h5>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </div>
        <PurchasingModal />
        <PaymentModal />
        <!-- <pre>{{ vendor }}</pre> -->
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { vendorUrl, getHeader } from '../../config'
import PurchasingModal from '@/components/purchasing/PurchasingModal.vue'
import PaymentModal from '@/components/payment/PaymentGroupModal.vue'

export default {
  name: 'VendorForm',
  props: ['vendor'],
  components: {
    PurchasingModal,
    PaymentModal
  },
  computed: {
    ...mapState({
      cityList: state => state.city.cityList,
      stateList: state => state.state.stateList,
      vendorTypeList: state => state.vendors.vendorTypeList
    }),
    contact: function () {
      return this.vendor.contact[0]
    },
    getPayment: function () {
      return this.vendor.payments.filter(d => d.id !== null)
    },
    getTotalPayment: function () {
      var sum = 0
      var array = this.vendor.payments
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price)
      }
      return sum
    },
    getTotalPurchasing: function () {
      var sum = 0
      var array = this.vendor.purchasing
      for (let i = 0; i < array.length; i++) {
        sum += parseInt(array[i].qty) * parseFloat(array[i].price)
      }
      return sum
    }
  },
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    updateVendor () {
      axios.put(vendorUrl + '/' + this.vendor.id, this.vendor, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Successfully',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            '',
            'error'
          )
        })
    },
    createVendor () {
      axios.post(vendorUrl, this.vendor, { headers: getHeader() })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(response => {
          console.log(response)
          this.$swal(
            'Error!!',
            response.data,
            'error'
          )
        })
    },
    toPurchasing: function (po) {
      this.$router.push({ name: 'purchasing', query: { purchasing: po, form: 'true', ref: 'vendor', refNo: this.vendor.id } })
    },
    showPurchasingNo (no) {
      var payload = {
        purchasing_no: no
      }
      this.$store.commit('SET_PURCHASING_ID', payload)
      this.$store.dispatch('getPurchasingShowByNo', payload)
    },
    showPaymentNo (no) {
      var payload = {
        group_no: no
      }
      console.log(payload)
      this.$store.dispatch('getPaymentByNo', payload)
    }
  }
}
</script>
